import React from 'react';
import { Navbar } from './components/portfolio/Navbar';
import { Hero } from './components/portfolio/Hero';
import { Stats } from './components/portfolio/Stats';
import { About } from './components/portfolio/About';
import { Experience } from './components/portfolio/Experience';
import { Skills } from './components/portfolio/Skills';
import { Certifications } from './components/portfolio/Certifications';
import { Projects } from './components/portfolio/Projects';
import { Insights } from './components/portfolio/Insights';
import { Contact } from './components/portfolio/Contact';
import { Footer } from './components/portfolio/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <About />
        <Experience />
        <Skills />
        <Certifications />
        <Projects />
        <Insights />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;